<template>
    <div>
        <Dialog v-bind:value="value" @input="$emit('input', $event)"
                title="Template laden" width="1100px"
                @cancel="$emit('input', false)" hide-buttons
                @ok="$emit('ok')" :loading="false" style="position: relative"
        >
            <div class="d-flex align-center">
                <LiveStageToggle style="width: 150px" v-model="selectedType"></LiveStageToggle>
                <SiteSelect style="width:40%" hide-add v-model="selectedSite" hide-details
                            ignore-publisher-filter :loading="siteLoading"></SiteSelect>
                <SitetypeSelect style="width:40%"
                                v-model="selectedSitetype"
                                :siteDetails="siteDetails ? siteDetails : {}"
                                hide-buttons :loading="sitetypeLoading"></SitetypeSelect>
            </div>
            <Datatable title="Templates" :items="templateKeys" :headers="headers" dense :items-per-page="-1"
                       itemSlot="item:completeKey"
                       @click:row="$emit('click:row', emitData($event))"
            >
                <template #item:completeKey="item">
                    <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                            <v-chip class="font-weight-bold" dark label small
                                    v-bind="attrs"
                                    v-on="on"
                                    color="blue-grey lighten-2">
                                Template Key
                            </v-chip>
                        </template>
                        <span>{{ item.completeKey }}</span>
                    </v-tooltip>
                </template>
            </Datatable>
        </Dialog>
    </div>
</template>

<script>
import Dialog from "../../components/Dialog";
import Datatable from "../../components/Tables/Datatable";
import LiveStageToggle from "./components/LiveStageToggle";
import SiteSelect from "../components/SiteSelect";
import SitetypeSelect from "../components/SitetypeSelect";
import Utils from "../../scripts/Utils";

export default {
    name: "JsonLoadTemplateDialog",
    props: ['value', 'type'],
    components: {SitetypeSelect, SiteSelect, LiveStageToggle, Datatable, Dialog},
    data: () => {
        return {
            headers: [
                {text: 'Seitentyp', value: 'type', width: '150px'},
                {text: 'Positionen', value: 'positions'},
                {text: 'Teasertyp', value: 'teasertypes', width: '200px'},
                {text: 'JSON Key', value: 'completeKey', width: '1%'}
            ],
            selectedType: null,
            selectedSite: null,
            selectedSitetype: null,
            siteDetails: null,
            siteLoading: false,
            sitetypeLoading: false,
            jsonContent_live: null,
            jsonContent_stage: null,
            initializing: false,
        }
    },
    mounted() {
        this.init();
    },
    computed: {
        vuexState() {
            return this.$store.state.editor;
        },
        templateKeys() {
            let ret = [];
            let json = this['jsonContent_' + this.selectedType] ? this['jsonContent_' + this.selectedType] : this.vuexState['jsonContent_' + this.selectedType];
            let keys = [];
            if (json && Object.keys(json).length !== 0) {
                Object.keys(json).forEach((key) => {
                    keys.push(Utils.parseJSONKey(key, this.vuexState.types, this.vuexState.teasertypes));
                })
                keys = Utils.sortJsonKeys(keys);
                keys.forEach((templateKey) => {
                    let tmp = JSON.parse(JSON.stringify(templateKey));
                    tmp.positions = tmp.positions.join(', ');
                    tmp.teasertypes = tmp.teasertypes.join(', ');
                    tmp.type = tmp.type.name;
                    ret.push(tmp);
                })
            }
            return ret;
        }
    },
    methods: {
        init() {
            if (this.vuexState.siteDetails) {
                this.initializing = true;
                this.selectedType = this.type;
                this.selectedSite = this.vuexState.selectedSite;
                this.selectedSitetype = this.vuexState.selectedSitetype;
                this.siteDetails = this.vuexState.siteDetails;
                this.jsonContent_live = this.vuexState.jsonContent_live;
                this.jsonContent_stage = this.vuexState.jsonContent_stage;
                this.initializing = false;
            }
        },
        async fetchSiteDetails() {
            this.siteLoading = true;
            this.siteDetails = await this.$store.dispatch('editor/fetchSiteDetails', {
                siteId: this.selectedSite.SiteId,
                noCommit: true
            });
            this.siteLoading = false;
        },
        async fetchJson() {
            this.sitetypeLoading = true;
            let data = await this.$store.dispatch('editor/fetchJSON', {
                id: this.selectedSitetype.SitetypeId,
                return: true
            });
            const validResults = data.filter(result => !(result instanceof Error));
            let res_live = validResults.find(x => x.config.url.indexOf(this.vuexState.baseDomain_live_cache) !== -1 || x.config.url.indexOf(this.vuexState.baseDomain_live) !== -1);
            let res_stage = validResults.find(x => x.config.url.indexOf(this.vuexState.baseDomain_stage) !== -1);
            this.jsonContent_live = res_live ? res_live.data : {};
            this.jsonContent_stage = res_stage ? res_stage.data : {};
            this.sitetypeLoading = false;
        },
        emitData(event) {
            let ret = Utils.parseJSONKey(event.completeKey, this.vuexState.types, this.vuexState.teasertypes);
            ret.html = this['jsonContent_' + this.selectedType][event.completeKey];
            return ret;
        }
    },
    watch: {
        selectedSite() {
            if (this.selectedSite && !this.initializing) {
                this.fetchSiteDetails();
            }
        },
        selectedSitetype() {
            if (this.selectedSitetype && !this.initializing) {
                this.fetchJson();
            }
        },
        value() {
            if (this.value) this.init();
        }
    }
}
</script>

<style scoped>

</style>